export default "__VITE_PUBLIC_ASSET__dc4f236f__"